import { Component, ViewContainerRef, ViewChild } from '@angular/core';
import { SiteServices } from '../../services/siteservices';
import { ProviderContext, Providers } from '../../data/Entities';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'factorfrm',
    templateUrl: '/templates/get/Settings/factor_frm',
})
export class FactorComponent {
    public entity: any = {};

    constructor(public siteServices: SiteServices) {
        this.siteServices.provider_Execute(
            'settings',
            'GETSTATFACTOR',
            {},
            (data) => {
                this.entity = data.TagObject;
            }
        );
    }

    save() {
        this.siteServices.provider_Execute(
            'settings',
            'SAVESTATFACTOR',
            this.entity,
            (data) => {
                this.siteServices.success('OK');
                this.entity = data.TagObject;
            }
        );
    }
}
